import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AiService } from '../../services/ai.service';
import { ToastrService } from 'ngx-toastr';
import { AI_ASSISTANT_NAME } from 'src/app/_core/config/app-config.const';

@Component({
  selector: 'tangram-ai-suggest',
  templateUrl: './ai-suggest.component.html',
  styleUrls: ['./ai-suggest.component.scss']
})
export class AiSuggestComponent implements OnInit {
  @Input() videoId: string;
  @Input() pathwayId: string = '';
  @Input() isDashboard: boolean = false;
  @Input() subscriptionActive: boolean;

  // Parent should open its existing Add Question / Create Poll modal
  // pre-filled with the suggestion so the user can refine before submitting.
  @Output() addQuestion = new EventEmitter<any>();
  @Output() addPoll = new EventEmitter<any>();

  // Every user-facing label goes through this — the UI never names the
  // underlying model. See AI_ASSISTANT_NAME in app-config.const.ts.
  readonly aiName = AI_ASSISTANT_NAME;

  suggestions: any = null;
  isLoading: boolean = false;

  constructor(
    private aiService: AiService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  getSuggestions(provider: 'gemini' | 'claude' = 'claude') {
    // return; // TODO: Remove this once AI features are implemented
    const id = this.isDashboard ? this.pathwayId : this.videoId;
    if (!id) {
      return;
    }

    this.isLoading = true;
    this.suggestions = null;

    const request = this.isDashboard
      ? this.aiService.getTangramSuggestions(this.pathwayId, provider)
      : this.aiService.getMediaSuggestions(this.videoId, provider);

    request.subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.success && res.data) {
          this.suggestions = res.data.suggestions;
        }
      },
      (_error: any) => {
        this.isLoading = false;
        // Toastr is shown globally by HttpAPIInterceptor for all AI errors.
      }
    );
  }

  /** Canonical category keys used for CSS styling (open / multi / tf). */
  getQuestionCategory(type: string): 'open' | 'multi' | 'tf' {
    const t = (type || '').toLowerCase();
    if (t.includes('multiple') || t === 'mcq') return 'multi';
    if (t.includes('true') || t.includes('false') || t === 'tf') return 'tf';
    return 'open';
  }

  /**
   * Emit the suggestion so the parent can open its Add-Question modal
   * pre-filled. User refines the wording/options, then submits normally.
   */
  useQuestion(question: any) {
    this.addQuestion.emit(question);
  }

  /**
   * Emit the poll suggestion so the parent can open its Create-Poll modal
   * pre-filled for editing before submission.
   */
  usePoll(poll: any) {
    this.addPoll.emit(poll);
  }
}
